import React, { useEffect, useRef } from 'react';
import { useDataFormContext } from '@/context/FormDataContext';
import { Grid2, Button } from '@mui/material';
import { Wrapper } from './styles';

/**
 * @returns FormEnd component
 */
export default function FormEnd():React.JSX.Element {
  const {
    dataForm,
    currentAdm,
    metaDataTimes,
    setDataForm,
    setCurrentAdm,
    setMetaDataTimes,
    setCurrentFormStep,
    setCurrentFormVariation
  } = useDataFormContext();

  /**
   * resetNewShare
   * @return {void}
   */
  function resetNewShare(): void {
    setDataForm({
      ...dataForm,
      ...{
        traceId: undefined,
        registrationId: undefined,
        admId: 0,
        acceptPrivacyPolicy: false,
        value: undefined,
        goodType: undefined,
        remainingPayments: undefined,
        ownedAmount: undefined,
        isAwarded: undefined,
        isCanceled: undefined,
        awardedDate: undefined,
        attachmentName: undefined,
        attachmentPath: undefined,
        group: undefined,
        share: undefined,
        lgpd: undefined
      }
    });

    setCurrentAdm({
      ...currentAdm,
      ...{
        id: undefined,
        name: undefined
      }
    });

    setMetaDataTimes({
      ...metaDataTimes,
      ...{
        startedForm: undefined,
        acceptedPrivacyAndPolicyTerms: undefined,
        advancedToStepTwo: undefined,
        acceptedPartnerDataTerms: undefined,
        advancedToStepThree: undefined,
        finishedForm: undefined
      }
    });

    setCurrentFormStep(0);
    setCurrentFormVariation('all');
  }

  const inputRef = useRef(null) as any;
  useEffect(() => {
    if (inputRef.current) {
      const height = inputRef?.current?.offsetHeight;
      window.parent.postMessage(['setHeight', `${height + (height * 85/100)}`], '*');
    }
  }, []);

  return (
    <div ref={inputRef}>
      <Wrapper>
        <h2>Recebemos suas informações</h2>
        <p><span>Seus dados foram recebidos com sucesso.</span></p>
        <p>Faremos a análise da sua cota e em breve entraremos em contato por e-mail ou SMS.</p>
        <p>Fique atento à sua caixa de SPAM, nossos e-mails podem cair lá por engano!</p>
      </Wrapper>

      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, sm: 5 }}>
          <Button
            fullWidth
            variant='goFoward'
            onClick={resetNewShare}
          >
            Enviar outra cota
          </Button>
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 7 }}>
          <Button
            variant='goBack'
            fullWidth
            target='_blank'
            href="https://consorciei.com.br/vender-consorcio#faq">
            Aprenda mais sobre consórcio
          </Button>
        </Grid2>
      </Grid2>
    </div>
  );
}
